import { getLocale } from "../runtime";

const sv_remove = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ta bort`
};

const remove = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_remove(inputs)
	return "remove";
};

export { remove as "remove" };